import { formatDateTimeLocalInput } from "../../../../utils/DateUtils";

/** O atendimento é de um dia anterior a hoje? As datas vêm no formato local aaaa-mm-ddThh:mm. */
export const isBeforeToday = (scheduledLocal, nowLocal = formatDateTimeLocalInput()) => (
    Boolean(scheduledLocal) && scheduledLocal.slice(0, 10) < nowLocal.slice(0, 10)
);

/** A data da venda cai em um mês anterior ao atual? */
export const isInPreviousMonth = (requestDate, nowLocal = formatDateTimeLocalInput()) => (
    Boolean(requestDate) && requestDate.slice(0, 7) < nowLocal.slice(0, 7)
);
